<template>
  <div>
    <ul
      class="tgList"
      v-if="zhuantiChildrens.length>0"
    >
      <li
        v-for="(zhuantiList,index) in zhuantiChildrens"
        :key="index"
        @click="getZhuantiContent('zhuanti',index)"
      >
        <div class="tgListLeft">
          <h1>
            <span v-text="zhuantiList.name"></span>
          </h1>
          <h2
            v-if="zhuantiList.secondName!=undefined"
            v-html="zhuantiList.secondName.length>26?zhuantiList.secondName.substring(0,26)+'...':zhuantiList.secondName"
          ></h2>
        </div>
        <div class="tgListRight">
          <img :src="contentHost+zhuantiList.coverImageSmall" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import paramsHelper from '@/assets/js/parametersHelper'
export default {
    name: 'SpecialContentList',
    data () {
        return {
            contentHost: '',
            msg: '网络数据请求异常',
            bannerImg: '',
            zhuantiChildrens: [],
            id: '',
            name: '',
            mainerHeight: 'auto',
            gradeId:''
        }
    },
    created: function () {
        var that = this;
        var host = that.contentHost = sessionStorage.c_host;
        let { id, name, gradeId, index } = paramsHelper.decode(this.$route.query.params)
        Object.assign(this, {
            id,
            name,
            gradeId
        })
        that.getZhuantiList(id, name);
    },
    mounted: function () {
        var that = this;
        //_timer = window.setInterval(function(){that.initHeight();},100);
    },
    destroyed: function () {

    },
    methods: {
        initHeight: function () {
            var fsize = document.getElementsByTagName('html')[0].style.fontSize;
            if (fsize != '') {
                window.clearInterval(_timer);
                fsize = parseFloat(fsize);
                var _h = document.documentElement.clientHeight;
                var _h1 = 0.6 * fsize;
                var _h3 = _h - _h1;
                this.mainerHeight = _h3 + 'px';
            }
        },
        jumpTop: function () {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        getZhuantiList: function (id, name) {
            var that = this;
            if (sessionStorage.c_subZhuantiList) {
                that.zhuantiChildrens = JSON.parse(sessionStorage.c_subZhuantiList);
            }
        },
        getZhuantiContent: function (name, index) {
            var that = this;
            this.$router.push({
                name: 'SpecialContent',
                query: { params: paramsHelper.encode({ id:that.id, name, index, gradeId: that.gradeId }),lessonId:this.$route.query.lessonId}
            })
        }
    }

}
</script>

<style scope lang="less">
</style>
